import React, { Component } from 'react';
import InverterEnergyChartOfWeek from './InverterEnergyChartOfWeek';
import InverterEnergyChartOfDay from './InverterEnergyChartOfDay';
import InverterEnergyChartOfMonth from './InverterEnergyChartOfMonth';
import InverterEnergyChartOfYear from './InverterEnergyChartOfYear';

class InverterEnergyGeneration extends Component {

    constructor(props) {
        super(props);
        this.state = {
            timeState: 'day'
        }
        this.handleButtonClick = this.handleButtonClick.bind(this);
    }

    getTimeButtonState(state) {
        if (this.state.timeState === state) {
            return "btn btn-default active bg-blue";
        }
        return "btn btn-default";
    }

    handleButtonClick(state) {
        this.setState({
            timeState: state
        });
    }

    getMainContent() {
        switch (this.state.timeState) {
            case 'day':
                return (
                    <InverterEnergyChartOfDay history={this.props.history} user={this.props.user} inverter={this.props.inverter} />
                )
            case 'week':
                return (
                    <InverterEnergyChartOfWeek history={this.props.history} user={this.props.user} inverter={this.props.inverter} />
                );
            case 'month':
                return (
                    <InverterEnergyChartOfMonth history={this.props.history} user={this.props.user} inverter={this.props.inverter} />
                )
            case 'year':
                return (
                    <InverterEnergyChartOfYear history={this.props.history} user={this.props.user} inverter={this.props.inverter} />
                )
            default:
                return (<div></div>);
        }

    }

    render() {
        return (
            <div className="">
                <div className="">
                    <div className="d-flex justify-content-end">
                        <div className="btn-group btn-group-toggle" data-toggle="buttons">
                            <label className={this.getTimeButtonState('day')} onClick={() => this.handleButtonClick('day')}>
                                <input type="radio" name="options" id="day" autoComplete="off" defaultChecked /> Day
                            </label>
                            <label className={this.getTimeButtonState('week')} onClick={() => this.handleButtonClick('week')}>
                                <input type="radio" name="options" id="week" autoComplete="off" /> Week
                            </label>
                            <label className={this.getTimeButtonState('month')} onClick={() => this.handleButtonClick('month')}>
                                <input type="radio" name="options" id="month" autoComplete="off" /> Month
                             </label>
                            <label className={this.getTimeButtonState('year')} onClick={() => this.handleButtonClick('year')}>
                                <input type="radio" name="options" id="year" autoComplete="off" /> Year
                             </label>
                        </div>
                    </div>
                    {this.getMainContent()}
                </div>
            </div>
        )
    }
}

export default InverterEnergyGeneration;